export const VIDEO_FILE = 'video'
export const AUDIO_FILE = 'audio'
export const TEXT_FILE = 'text'
export const PDF_FILE = 'pdf'
export const IMAGE_FILE = 'image'
export const SPREADSHEET_FILE = 'spreadsheet'
export const UNKNOWN_FILE = 'unknown'
export const DRM_FILE = 'drm'
export type FileType =
  | 'video'
  | 'audio'
  | 'text'
  | 'pdf'
  | 'image'
  | 'spreadsheet'
  | 'unknown'
  | 'drm'
